import { gql } from 'graphql-request';

export const REJECT_STAFF_INVITE = gql`
  mutation CoreEmployeeInvitations($invitationId: ID!) {
    coreEmployeeInvitations {
      acceptInvitation(input: { invitationId: $invitationId, isAccepted: false })
    }
  }
`;
